import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-drop-down",
  "use": "arrow-drop-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-drop-down\"><path d=\"M7 10l5 5 5-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol